// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1228":"68d42b55","1467":"0699b8b7","2578":"26897b13","2840":"d442ab49","4776":"68d42b55","5169":"d8fa452f","8149":"7d61aef9","9295":"d8fa452f"}[chunkId] + ".chunk.css";
};